<script setup>
  import { appName } from '@/config/app';
  const currentYear = new Date().getFullYear();
</script>

<template>
  <!-- Remove `absolute` to use sticky footer -->
  <v-footer absolute app>
    <v-row no-gutters class="px-4 w-100">
      <v-col class="text-center text-liv-footer-text-color">
        <p>&copy; {{ currentYear }} {{ appName }}. All rights reserved.</p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style scoped>
  .v-footer p {
    font-size: 0.8rem;
    flex-shrink: 0;
  }
</style>
